import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { RotaService } from '../../services/rota.service';
import { MegaMenuItem, MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-topbar',
  templateUrl: './app-topbar.component.html',
  styleUrls: ['./app-topbar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTopbarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isUserLoggedIn = false;
  userName: string = '';
  isMobile = false;
  sidebarVisible = false;
  loading = false;
  error: string | null = null;

  items: MegaMenuItem[] = [];
  mobileMenuItems: MenuItem[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private rotaService: RotaService,
    private keycloakService: KeycloakService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    void this.initializeComponent();

    const userData = this.authService.getUserData();
    if (userData) {
      this.userName = userData.usuario_nome ?? '';
    }
    this.initializeMenuItems();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async initializeComponent(): Promise<void> {
    try {
      this.loading = true;
      this.isUserLoggedIn = this.keycloakService.isLoggedIn();
      this.checkIsMobile();
      this.initializeMenuItems();
    } catch (error) {
      this.error = 'Erro ao inicializar o componente';
      console.error('Erro na inicialização:', error);
    } finally {
      this.loading = false;
      this.cdr.markForCheck();
    }
  }

  private initializeMenuItems(): void {
    const menu: MegaMenuItem[] = [];

    if (this.isUserLoggedIn) {
      menu.push(
        {
          label: 'Home',
          routerLink: ['/'],
        },
        {
          label: 'Conheça nossos prompts',
          routerLink: ['/resultados-busca'],
          queryParams: { search: '' },
        },
        {
          label: 'Sobre o Promptus',
          routerLink: ['/manual-prompt'],
        },
        {
          label: 'Cadastre seu prompt',
          routerLink: ['/cadastro-prompt'],
        },
        {
          label: 'Painel do Usuário',
          routerLink: ['/painel'],
        },
        {
          label: 'Perfil',
          icon: 'pi pi-user',
          items: [
            [
              {
                label: 'Bem-vindo',
                items: [
                  {
                    label: this.userName,
                    icon: 'pi pi-user',
                  },
                  {
                    label: 'Perfil',
                    icon: 'pi pi-cog',
                    routerLink: ['/perfil'],
                  },
                  {
                    label: 'Sair',
                    icon: 'pi pi-sign-out',
                    command: () => this.logout(),
                  },
                ],
              },
            ],
          ],
        }
      );
    } else {
      // Se não estiver logado, mostra a opção de login
      menu.push(
        {
          label: 'Home',
          routerLink: ['/'],
        },
        {
          label: 'Conheça nossos prompts',
          command: () => this.keycloakService.login(),
          queryParams: { search: '' },
        },
        {
          label: 'Sobre o Promptus',
          command: () => this.keycloakService.login(),
        },
        {
          label: 'Cadastre seu prompt',
          command: () => this.keycloakService.login(),
        },
        {
          label: 'Login',
          icon: 'pi pi-user',
          command: () => this.keycloakService.login(),
        }
      );
    }

    this.items = menu;
    // gera também os itens para mobile
    this.mobileMenuItems = this.convertMegaToPanelItems(this.items);
  }

  private convertMegaToPanelItems(megaItems: MegaMenuItem[]): MenuItem[] {
    return megaItems.map((item) => {
      const panelItem: MenuItem = {
        label: item.label,
        icon: item.icon,
        routerLink: item.routerLink,
        command: item.command,
        items: [],
        expanded: false,
      };

      if (item.items) {
        panelItem.items = item.items
          .flatMap((column) => column)
          .flatMap((group) => {
            if (group.items) {
              return group.items.map((subItem) => ({
                label: subItem.label,
                icon: subItem.icon,
                routerLink: subItem.routerLink,
              }));
            }
            return [];
          });
      }

      return panelItem;
    });
  }

  private checkIsMobile(): void {
    this.isMobile = window.innerWidth <= 768;
  }

  toggleSidebar(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }

  entrar() {
    if (this.isUserLoggedIn) {
      this.rotaService.navegarPara('/painel');
    } else {
      this.keycloakService.login();
    }
  }

  // navigateToProfile(): void {
  //   this.router.navigate(['/perfil']);
  // }

  logout(): void {
    this.keycloakService.logout(window.location.origin);
    this.router.navigate(['/home']);
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.checkIsMobile();
  }
}
